import '../App.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Demo() {
  return (
    <div className="layout-container" style={{ minHeight: '100vh' }}>
      <div className="container">
        <Header />
        
        <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent)' }}>
            Styling Test Page
          </h1>
          
          <div style={{ display: 'grid', gap: '1rem' }}>
            <div style={{ 
              padding: '2rem', 
              background: 'var(--panel)', 
              border: '1px solid var(--border)',
              borderRadius: '1rem'
            }}>
              <h2>This is a test panel</h2>
              <p>This content should use variables from our theme system.</p>
            </div>
            
            <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
              <button className="btn btn-primary">Primary Button</button>
              <button className="btn btn-outline">Outline Button</button>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}


